<template>
  <div>
    <div style="overflow: hidden; margin-top: -1.8rem">
      <div class="mb-3 d-flex" style="gap: 10px; margin-top: 1rem">
        <!--  action buttons -->
        <button class="tab-btn btn-info" @click="goBack">
          Back to all agents
        </button>

        <button
          class="tab-btn btn-info"
          v-if="isAgentDisabled"
          @click="disable"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          disable login access
        </button>

        <button
          class="tab-btn btn-info"
          v-if="isAgentEnabled"
          @click="enable"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          enable login access
        </button>

        <button
          class="tab-btn btn-info"
          v-if="isAgentActivated"
          @click="activate"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          activate agent
        </button>

        <button
          class="tab-btn btn-info"
          v-if="isPNDActivated('inactive')"
          :style="{ display: isAgent ? 'none' : 'block' }"
          @click="doActivatePND"
        >
          Activate PND
        </button>

        <button
          class="tab-btn btn-info"
          v-if="isPNDActivated('active')"
          @click="doDeactivatePND"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Deactivate PND
        </button>

        <button
          class="tab-btn btn-info"
          v-if="wallet.liens && wallet.liens.length === 0"
          :style="{ display: isAgent ? 'none' : 'block' }"
          @click="openPlaceLienModal"
        >
          Place LIEN
        </button>

        <button
          class="tab-btn btn-info"
          v-if="wallet.liens && wallet.liens.length > 0"
          @click="openUpdatePlaceLienModal"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          View LIEN
        </button>
      </div>

      <!--  heading -->
      <div class="cont">
        <div class="d-flex justify-content-between align-items-center">
          <div class="account">
            <label for="account-type">Account Type</label>
            <p class="d-flex align-items-center">
              {{
                agent && agent.accountType
                  ? capitalize(agent.accountType.replace("-", " "))
                  : "--"
              }}
            </p>
          </div>

          <button
            class="tab-btn btn-info"
            :style="{ display: isAgent ? 'none' : 'block' }"
            @click="toggleEditMode"
            style="height: fit-content"
          >
            {{ isEditable ? "Cancel" : "Edit" }}
          </button>
        </div>

        <!--  tab sections -->
        <div class="tab-items">
          <button
            v-for="section in filteredSections"
            :key="section.key"
            class="section-button"
            :class="{ active: visibleSection === section.key }"
            @click="toggleSection(section.key)"
          >
            {{ section.label }}
          </button>
        </div>

        <!--  category label -->
        <h4 class="heading my-n1">{{ currentSectionLabel }}</h4>

        <div>
          <!--  personal information -->
          <div v-if="visibleSection === 'personal'">
            <div v-if="agent">
              <Input
                :fields="editableFields"
                :getOptions="getOptions"
                :disabled="!isEditable"
                :onClick="handleFieldClick"
                :onChange="handleSelectChange"
              />

              <!--  agent merchant -->
              <div>
                <h4 class="heading">Agent's Category</h4>
                <div class="row" style="row-gap: 30px">
                  <div class="col-md-4">
                    <!-- <label for="agent-merchant">Merchant</label> -->
                    <select
                      id="agent-merchant"
                      class="form-control"
                      placeholder="Select Merchant"
                      :disabled="!isEditable"
                      v-model="selectedMerchant"
                    >
                      <option value="">Select merchant</option>
                      <option
                        v-for="merchant in utils.merchants"
                        :key="merchant._id"
                        :value="merchant._id"
                      >
                        {{ merchant.merchantName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- sales officer -->

              <div class="col-md-4">
                <h4>Agent’s Sales Officer</h4>

                <label>Sales Officer </label>

                <v-select
                  v-model="selectedSalesOfficer"
                  :options="formattedSalesOfficers"
                  :reduce="(officer) => officer._id"
                  label="fullName"
                  :disabled="!isEditable"
                  placeholder="Select Sales Officer"
                  searchable
                  style="border: none; font-size: 12px"
                />
              </div>

              <!--  activation -->
              <div>
                <h4 class="heading">Activation Details</h4>
                <Input :fields="activationDetails" disabled="disabled" />
              </div>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section</p>
            </div>
          </div>

          <!--  business information -->
          <div v-if="visibleSection === 'business'">
            <div v-if="agent">
              <Input
                :fields="editableFields"
                :getOptions="getOptions"
                :onChange="handleSelectChange"
                :disabled="!isEditable"
              />

              <!--  source of income -->
              <div class="mt-5">
                <h4 class="heading">Source of Income</h4>

                <Input
                  :fields="filteredBusinessIncome"
                  :getOptions="getOptions"
                  :onChange="handleSelectChange"
                  :disabled="!isEditable"
                />
              </div>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section.</p>
            </div>
          </div>

          <!--  directors information -->
          <div v-if="visibleSection === 'directors'">
            <div v-if="agent.directors && agent.directors.length">
              <div class="info-wrap">
                <div
                  v-for="(director, directorIndex) in visibleEntries.directors"
                  :key="`director-${directorIndex}`"
                >
                  <p class="sub-heading">Director {{ directorIndex + 1 }}</p>
                  <Input
                    :fields="getEntityFields('directors', directorIndex)"
                  />
                </div>
              </div>

              <span
                class="view-more"
                @click="toggleState('showAllDirectors')"
                v-if="agent.directors.length > 1"
              >
                {{
                  showAllDirectors
                    ? "Hide additional directors"
                    : "View more directors"
                }}
              </span>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section</p>
            </div>
          </div>

          <!--  shareholders information -->
          <div v-if="visibleSection === 'shareholders'">
            <div v-if="agent.shareholders && agent.shareholders.length">
              <div class="info-wrap">
                <div
                  v-for="(share, shareIndex) in visibleEntries.shareholders"
                  :key="`share-${shareIndex}`"
                >
                  <p class="sub-heading">Shareholder {{ shareIndex + 1 }}</p>
                  <Input
                    :fields="getEntityFields('shareholders', shareIndex)"
                  />
                </div>
              </div>

              <span
                v-if="agent.shareholders.length > 1"
                class="view-more"
                @click="toggleState('showAllShareholders')"
              >
                {{
                  showAllShareholders
                    ? "Hide additional shareholders"
                    : "View more shareholders"
                }}
              </span>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section</p>
            </div>
          </div>

          <!-- trustees information -->
          <div v-if="visibleSection === 'trustees'">
            <div
              v-if="agent.registeredTrustees && agent.registeredTrustees.length"
            >
              <div class="info-wrap">
                <div
                  v-for="(trustee, trusteeIndex) in visibleEntries.trustees"
                  :key="`trustee-${trusteeIndex}`"
                >
                  <p class="sub-heading">Trustee {{ trusteeIndex + 1 }}</p>
                  <Input
                    :fields="
                      getEntityFields('registeredTrustees', trusteeIndex)
                    "
                  />
                </div>
              </div>

              <span
                v-if="agent.registeredTrustees.length > 1"
                class="view-more"
                @click="toggleState('showAllTrustees')"
              >
                {{
                  showAllTrustees
                    ? "Hide additional trustees"
                    : "View more trustees"
                }}
              </span>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section</p>
            </div>
          </div>

          <!--  authorizers information -->
          <div v-if="visibleSection === 'authorizers'">
            <div
              v-if="
                agent.nominatedAuthorizer && agent.nominatedAuthorizer.length
              "
            >
              <div
                v-for="(
                  authorizer, authorizerIndex
                ) in agent.nominatedAuthorizer"
                :key="`authorizer-${authorizerIndex}`"
              >
                <Input :fields="allInformation" />
              </div>
            </div>

            <div v-else>
              <p class="no-info">No Information available for this section</p>
            </div>
          </div>

          <!--  kyc information -->
          <div v-if="visibleSection === 'kyc'">
            <div class="row d-flex flex-wrap" style="row-gap: 15px">
              <div
                v-for="document in filteredDocuments"
                :key="document.key"
                class="col-md-4 d-flex flex-column kyc-file"
              >
                <label for="inlineFormInput">{{ document.name }}</label>

                <input
                  :id="'fileInput_' + document.key"
                  type="file"
                  :disabled="!isEditable"
                  class="form-control d-none"
                  @change="(e) => handleFileUpload(e, document.key)"
                />

                <label
                  :for="'fileInput_' + document.key"
                  class="file-label"
                  :class="{ disabled: !isEditable }"
                  >Choose File</label
                >

                <div
                  class="file-name d-flex align-items-center justify-content-between"
                >
                  <span>{{ document.fileName }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="agent.kycDocuments && agent.kycDocuments.length"
              class="kyc-uploaded"
            >
              <h4 class="heading">Uploaded Documents</h4>

              <div class="documents-container">
                <div
                  v-for="(document, index) in agent.kycDocuments"
                  :key="document._id"
                >
                  <p>{{ formatDocumentName(document.name) }}</p>

                  <template v-if="isImage(document.url)">
                    <div
                      class="document-wrapper"
                      :class="{ hovered: isHovered === index }"
                      @mouseover="isHovered = index"
                      @mouseleave="isHovered = null"
                    >
                      <img
                        :src="document.url"
                        :alt="`Uploaded Document: ${document.name}`"
                        class="uploaded-img"
                      />
                      <button
                        v-show="isHovered === index"
                        @click="openPreview(document.url)"
                        class="btn-normal btn-preview"
                      >
                        View
                      </button>
                    </div>
                  </template>

                  <template v-else>
                    <div class="pdf-preview-container">
                      <img
                        src="../assets/img/pdf.png"
                        alt="PDF Document"
                        class="pdf-icon"
                      />

                      <button
                        @click="downloadPdf(document.url)"
                        class="btn-normal btn-download"
                      >
                        Download PDF
                      </button>
                    </div>
                  </template>
                </div>
              </div>

              <div v-if="showPreview" class="preview">
                <div
                  style="position: relative; background: white; padding: 2px"
                >
                  <button @click="closePreview" class="btn-close">
                    &times;
                  </button>

                  <img
                    :src="previewUrl"
                    alt="Preview"
                    style="max-width: 100%; max-height: 80vh"
                  />
                </div>
              </div>
            </div>

            <div v-else>
              <p class="no-info">No document has been submitted.</p>
            </div>
          </div>

          <div class="d-flex justify-content-center my-5">
            <button
              class="tab-btn btn-info d-flex align-items-center update-btn"
              :disabled="!isEditable"
              @click="updateStep"
            >
              <span v-if="isUpdating" class="spin"></span>
              update account
            </button>
          </div>
        </div>
      </div>
    </div>

    <PlaceLienModal
      :isVisible="showPlaceLienModal"
      :agentId="agent._id"
      :isEditLien="isEditLien"
      @close="closeLienModal"
      :agentLienDetails="agentLienDetails"
    />
  </div>
</template>

<script>
import axios from "../store/axios";
import Swal from "sweetalert2";
import Modal from "../pages/Modals/Modal.vue";
import DynamicSection from "../components/DynamicSection.vue";
import Input from "../components/Inputs/Input.vue";
import { mapState, mapActions } from "vuex";
import {
  capitalize,
  formatDate,
  maskNumber,
  formatDocumentName,
} from "../utils/utils";
import {
  sections,
  companyTypes,
  annualIncome,
  businessIncome,
  businessIndustries,
  partnershipBusiness,
  otherOccupation,
  requiredDocuments,
  socialMedia,
  kycCategories,
} from "../constants/agents-information";
import {
  categoryTabs,
  tabs,
  personalInformation,
  activationDetails,
  businessInformation,
  allInformation,
} from "../constants/kyc";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PlaceLienModal from "../pages/Modals/PlaceLienModal.vue";

export default {
  components: {
    Modal,
    DynamicSection,
    Input,
    vSelect,
    PlaceLienModal,
  },
  data() {
    return {
      isUpdating: false,
      isEditable: false,
      showModal: false,
      showAllDirectors: false,
      showAllShareholders: false,
      showAllTrustees: false,
      isHovered: false,
      showPreview: false,
      visibleSection: "personal",
      selectedMerchant: "",
      selectedSalesOfficer: "",
      uploadedDocs: {},
      agent: {},
      wallet: {
        pnd: {
          status: "",
        },
        liens: [],
      },
      documentsToUpload: [],
      merchantOptions: [],
      categoryTabs,
      sections,
      tabs: tabs,
      personalInformation,
      businessInformation,
      allInformation,
      companyTypes,
      annualIncome,
      businessIncome,
      businessIndustries,
      partnershipBusiness,
      otherOccupation,
      activationDetails,
      requiredDocuments,
      socialMedia,
      kycCategories,
      bvnValue: null,
      ninValue: null,
      isBvnVisible: false,
      isNinVisible: false,
      userType: localStorage.getItem("userType"),
      allSalesOfficers: [],
      isEditLien: null,
      showPlaceLienModal: false,
      agentLienDetails: {},
    };
  },
  computed: {
    isAgent() {
      return this.userType === "Merchant";
    },
    ...mapState(["auth", "utils"]),
    filteredSections() {
      const allowedTabs = this.categoryTabs[this.agent.businessCategory] || [
        "personal",
        "business",
      ];
      return this.sections.filter((section) =>
        allowedTabs.includes(section.key),
      );
    },
    isAgentActivated() {
      return this.agent.activatedAt === null;
    },

    isLien() {
      return this.wallet.liens.length;
    },

    isAgentEnabled() {
      return this.agent.disabled === true;
    },
    isAgentDisabled() {
      return this.agent.disabled === false;
    },
    currentSectionLabel() {
      const currentSection = this.sections.find(
        (section) => section.key === this.visibleSection,
      );
      return currentSection ? currentSection.label : "";
    },
    visibleEntries() {
      return {
        directors: this.showAllDirectors
          ? this.agent.directors || []
          : (this.agent.directors || []).slice(0, 1),
        shareholders: this.showAllShareholders
          ? this.agent.shareholders || []
          : (this.agent.shareholders || []).slice(0, 1),
        trustees: this.showAllTrustees
          ? this.agent.registeredTrustees || []
          : (this.agent.registeredTrustees || []).slice(0, 1),
      };
    },
    filteredDocuments() {
      return this.documentsToUpload
        .map((key) => {
          const doc = this.requiredDocuments.find((d) => d.key === key);
          if (doc) {
            return {
              ...doc,
              fileName: doc.fileName || "",
            };
          }
          return null;
        })
        .filter(Boolean);
    },
    uploadedDocuments() {
      return this.filteredDocuments.filter((doc) => doc.file);
    },
    currentFields() {
      const mapping = {
        personal: personalInformation,
        business: businessInformation,
        directors: allInformation,
        shareholders: allInformation,
        trustees: allInformation,
      };
      return mapping[this.visibleSection];
    },

    editableFields() {
      const sectionConfig = {
        personal: {
          fields: this.personalInformation,
          editableKeys: [
            "address",
            "landmark",
            "stateOfResidence",
            "lgaOfResidence",
            "socialMediaPlatform",
            "socialMediaHandle",
            "email",
          ],
        },
        business: {
          fields: this.businessInformation,
          editableKeys: [
            "businessIndustry",
            "businessState",
            "businessLGA",
            "businessAddress",
            "businessPhoneNumber",
            "businessEmail",
            "isPartnershipBusiness",
          ],
        },
        directors: {
          fields: this.getEntityFields("directors"),
          editableKeys: [],
        },
        shareholders: {
          fields: this.getEntityFields("shareholders"),
          editableKeys: [],
        },
        trustees: {
          fields: this.getEntityFields("registeredTrustees"),
          editableKeys: [],
        },
      }[this.visibleSection] || { fields: [], editableKeys: [] };

      return sectionConfig.fields.map((field) => {
        const baseField = {
          ...field,
          disabled:
            !this.isEditable || !sectionConfig.editableKeys.includes(field.key),
        };

        if (field.key === "bvnValid" || field.key === "nin") {
          return {
            ...baseField,
            value:
              field.key === "bvnValid"
                ? this.bvnValue
                  ? this.bvnValue
                  : field.value
                  ? true
                  : false
                : this.ninValue
                ? this.ninValue
                : field.value
                ? true
                : false,

            disabled: true,
          };
        }

        return baseField;
      });
    },
    filteredBusinessIncome() {
      const hasMultipleSources = this.agent.sourcesOfIncome.length > 1;
      const othersSelected =
        this.businessIncome.find((f) => f.key === "others").value === "yes";

      return this.businessIncome.filter(
        ({ key }) =>
          hasMultipleSources ||
          key === "others" ||
          othersSelected ||
          !["otherIndustry", "otherAnnualIncome"].includes(key),
      );
    },

    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },
  methods: {
    capitalize,
    formatDate,
    maskNumber,
    formatDocumentName,
    ...mapActions([
      "getMerchants",
      "getStates",
      "getLgas",
      "updateAgent",
      "activateAgent",
      "enableAgent",
      "disableAgent",
      "activatePND",
    ]),
    isPNDActivated(status) {
      return this.wallet.pnd.status === status || "";
    },
    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
    },
    refreshPage() {
      window.location.reload();
    },
    toggleEditMode() {
      this.isEditable = !this.isEditable;
    },
    toggleSection(section) {
      this.visibleSection = section;
    },
    toggleState(property) {
      this[property] = !this[property];
    },
    openPreview(url) {
      this.previewUrl = url;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.previewUrl = "";
    },
    async openPlaceLienModal() {
      this.isEditLien = false;
      this.showPlaceLienModal = true;
    },
    async openUpdatePlaceLienModal() {
      this.isEditLien = true;
      this.showPlaceLienModal = true;
      this.agentLienDetails = this.wallet.liens[0];
    },

    closeLienModal() {
      this.showPlaceLienModal = false;
      this.showUpdateLienModal = false;
      this.isEditLien = null;
      this.getAgent();
    },
    isImage(fileUrl) {
      const imageExtensions = ["jpg", "jpeg", "png", "image/png"];
      const extension = fileUrl.split(".").pop().toLowerCase();
      return imageExtensions.includes(extension);
    },
    async handleFileUpload(event, documentKey) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/bmp",
      ];

      if (!allowedTypes.includes(file.type)) {
        this.$toast.error(
          "Only PDF, PNG, JPG, GIF, and BMP files are allowed.",
        );
        return;
      }

      const documentIndex = this.filteredDocuments.findIndex(
        (doc) => doc.key === documentKey,
      );

      if (documentIndex !== -1) {
        this.$set(this.filteredDocuments, documentIndex, {
          ...this.filteredDocuments[documentIndex],
          file,
          fileName: file.name,
        });

        this.$forceUpdate();
      }
    },
    downloadPdf(url) {
      window.open(url, "_blank");
    },
    getOptions(fieldKey) {
      const optionsMap = {
        businessState: this.utils.allStates,
        stateOfResidence: this.utils.allStates,
        businessLGA: (this.utils.lgasOfOrigin || []).map((lga) => ({
          key: lga.name,
          label: lga.name,
        })),
        lgaOfResidence: (this.utils.lgasOfResidence || []).map((lga) => ({
          key: lga.name,
          label: lga.name,
        })),
        businessIndustry: businessIndustries,
        isPartnershipBusiness: partnershipBusiness,
        businessType: this.getFilteredCompanyTypes(),
        socialMediaPlatform: socialMedia,
        annualIncome: annualIncome,
        otherIndustry: businessIndustries,
        otherAnnualIncome: annualIncome,
        others: otherOccupation,
      };

      const rawOptions = optionsMap[fieldKey] || [];

      return rawOptions.map((option) => {
        if (typeof option === "string") {
          return {
            label: option,
            key: option,
            value: option,
          };
        }

        return option;
      });
    },
    getEntityFields(entityType, index) {
      const entityList = this.agent[entityType] || [];
      const entityData = entityList[index] || {};

      return this.allInformation.map((field) => {
        let fieldValue = entityData[field.key] || "";

        if (field.key === "bvn") {
          fieldValue = entityData.bvn ? true : false;
        }

        if (field.key === "nin") {
          fieldValue = entityData.nin ? true : false;
        }

        if (field.key === "dateOfBirth") {
          fieldValue = formatDate(fieldValue);
        }

        if (field.key === "lga") {
          fieldValue = entityData.lga || "";
        }

        return {
          ...field,
          value: fieldValue,
          key: `${entityType}[${index}].${field.key}`,
        };
      });
    },
    async updateStep() {
      if (this.visibleSection === "personal") {
        this.updatePersonalInformation();
      } else if (this.visibleSection === "business") {
        this.updateBusinessInformation();
      } else if (this.visibleSection === "directors") {
        this.updateDirectorsInformation();
      } else if (this.visibleSection === "shareholders") {
        this.updateShareholdersInformation();
      } else if (this.visibleSection === "trustees") {
        this.updateTrusteesInformation();
      } else if (this.visibleSection === "authorizers") {
        this.updateAuthorizersInformation();
      } else if (this.visibleSection === "kyc") {
        this.updateKycDocuments();
      }
    },
    // async fetchLgas(state) {
    //   await this.getLgas(state).then((lgas) => (this.utils.lgas = lgas));
    // },
    // handleSelectChange(value, key) {
    //   if (key === "businessState") this.fetchLgas(value);
    // },

    async fetchLgas(state, type = "residence") {
      if (!state) return;

      try {
        this.activeLgaType = type;

        if (type === "residence") this.utils.lgasOfResidence = [];
        else if (type === "business") this.utils.lgasOfOrigin = [];

        this.$store.dispatch("getLgas", state);
      } catch (error) {
        console.error("Failed to fetch LGAs:", error);
      }
    },

    handleSelectChange(value, key) {
      if (key === "stateOfResidence") {
        this.fetchLgas(value, "residence");
      } else if (key === "businessState") {
        this.fetchLgas(value, "origin");
      }
    },

    getFilteredCompanyTypes() {
      if (!this.agent.businessCategory) return companyTypes;

      if (this.agent.businessCategory === "sole-proprietor") {
        return companyTypes.filter((type) => type.key === "Business Name (BN)");
      }

      if (this.agent.businessCategory === "private-limited-liability-company") {
        return companyTypes.filter(
          (type) => type.key === "Registered Company (RC)",
        );
      }

      return companyTypes;
    },
    populateFields(fields, agentData) {
      const findMatchingOption = (fieldKey, value) => {
        const options = this.getOptions(fieldKey);

        return options.find((option) => {
          const formattedKey = option.key.replace(/ State$/, "").toLowerCase();
          const formattedLabel = option.label
            .replace(/ State$/, "")
            .toLowerCase();
          return (
            formattedKey === value.toLowerCase() ||
            formattedLabel === value.toLowerCase()
          );
        });
      };

      return fields.map((field) => {
        const fieldValue = agentData[field.key];

        const keys = field.key.split(".");

        let formattedValue = keys.reduce(
          (acc, key) => acc && acc[key],
          agentData,
        );

        if (field.key === "nin") {
          return {
            ...field,
            value: fieldValue ? true : true,
          };
        }

        if (field.key === "gender") {
          formattedValue = formattedValue.toLowerCase();
        }

        if (
          field.key === "annualIncome" &&
          agentData.sourcesOfIncome &&
          agentData.sourcesOfIncome[0]
        ) {
          return {
            ...field,
            value: agentData.sourcesOfIncome[0].annualIncome,
          };
        }

        if (field.key === "otherIndustry" && agentData.sourcesOfIncome[1]) {
          return {
            ...field,
            value: agentData.sourcesOfIncome[1].industry,
          };
        }

        if (field.key === "otherAnnualIncome" && agentData.sourcesOfIncome[1]) {
          return {
            ...field,
            value: agentData.sourcesOfIncome[1].annualIncome,
          };
        }

        if (field.key === "businessType") {
          return {
            ...field,
            value: agentData.businessType,
          };
        }

        if (field.key === "isPartnershipBusiness") {
          return {
            ...field,
            value: Boolean(agentData[field.key]),
          };
        }

        if (field.key === "businessCategory") {
          return {
            ...field,
            value: fieldValue ? formatDocumentName(fieldValue) : "",
          };
        }

        if (field.key === "socialMediaPlatform") {
          return {
            ...field,
            value: agentData.socialMedia.socialMediaPlatform,
          };
        }

        if (field.key === "socialMediaHandle") {
          return {
            ...field,
            value: agentData.socialMedia.socialMediaHandle,
          };
        }

        if (formattedValue) {
          if (
            field.key === "dateOfBirth" ||
            field.key === "activatedAt" ||
            field.key === "registrationDate"
          )
            formattedValue = formatDate(formattedValue);

          if (field.key === "businessState") {
            const matchingOption =
              findMatchingOption(field.key, fieldValue) || "";

            if (matchingOption) {
              return {
                ...field,
                value: matchingOption.key,
              };
            }
          }

          if (field.key === "state") {
            const matchingOption =
              findMatchingOption(field.key, fieldValue) || "";

            if (matchingOption) {
              return {
                ...field,
                value: matchingOption.key,
              };
            }
          }

          if (field.key === "businessLGA") {
            this.fetchLgas(agentData.businessState);

            const matchingOption =
              findMatchingOption(field.key, fieldValue) || "";

            if (matchingOption) {
              return {
                ...field,
                value: matchingOption.key,
              };
            }
          }

          if (field.key === "lgaOfResidence") {
            this.fetchLgas(agentData.stateOfResidence);

            const matchingOption =
              findMatchingOption(field.key, fieldValue) || "";

            if (matchingOption) {
              return {
                ...field,
                value: matchingOption.key,
              };
            }
          }

          if (field.key === "nin") {
            return {
              ...field,
              value: this.ninValue ? this.ninValue : fieldValue ? true : false,
            };
          }

          if (field.key === "gender") {
            formattedValue = formattedValue.toLowerCase();
          }

          if (field.key === "annualIncome" && agentData.sourcesOfIncome[0]) {
            return {
              ...field,
              value: agentData.sourcesOfIncome[0].annualIncome,
            };
          }

          if (field.key === "otherIndustry" && agentData.sourcesOfIncome[1]) {
            return {
              ...field,
              value: agentData.sourcesOfIncome[1].industry,
            };
          }

          if (
            field.key === "otherAnnualIncome" &&
            agentData.sourcesOfIncome[1]
          ) {
            return {
              ...field,
              value: agentData.sourcesOfIncome[1].annualIncome,
            };
          }

          if (field.key === "businessType") {
            return {
              ...field,
              value: agentData.businessType,
            };
          }

          if (field.key === "isPartnershipBusiness") {
            return {
              ...field,
              value: Boolean(agentData[field.key]),
            };
          }

          return {
            ...field,
            value: formattedValue,
          };
        }

        return field;
      });
    },
    async activate() {
      try {
        this.$confirm("Agent will be activated").then(() => {
          this.activateAgent({ id: this.agent._id });
          this.getAgent();
        });
      } catch (error) {
      } finally {
      }
    },
    enable() {
      this.$confirm("This agent's login access will be enabled").then(() => {
        this.enableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    disable() {
      this.$confirm("This agent's login access will be disabled").then(() => {
        this.disableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    async doActivatePND() {
      try {
        this.$confirm("Place Post No Debit on Account?").then(() => {
          this.activatePND({ agentId: this.agent._id, status: "active" });
          this.getAgent();
        });
      } catch (error) {
      } finally {
      }
    },
    async doDeactivatePND() {
      try {
        this.$confirm("Remove Post No Debit from Account?").then(() => {
          this.activatePND({ agentId: this.agent._id, status: "inactive" });
          this.getAgent();
        });
      } catch (error) {
      } finally {
      }
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );

        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
      }
    },

    async getAgent() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.$route.params.agentId}`,
        );

        if (response.status !== 200) return;

        const { agent, wallet } = response.data;

        if (!agent) return;

        this.agent = agent;
        this.wallet = wallet;

        this.selectedMerchant = agent.merchantId || "";
        // this.selectedSalesOfficer = agent.salesOfficerId

        [
          "personalInformation",
          "activationDetails",
          "businessInformation",
          "businessIncome",
        ].forEach((section) => {
          this[section] = this.populateFields(this[section], this.agent);
        });

        await this.getMerchants();
        await this.getSalesOfficers();
      } catch (err) {
        if (err.response.data) {
          // toast error message
        }
      }
    },
    async updateInformation(endpoint) {
      this.isUpdating = true;

      const payload = Object.fromEntries(
        this.editableFields
          .filter(({ disabled, value }) => !disabled && value !== "")
          .map(({ key, value }) => [
            key.includes(".") ? key.split(".").pop() : key,
            value,
          ]),
      );

      if (this.visibleSection === "personal") {
        payload.merchantId = this.selectedMerchant;
        payload.salesOfficerId = this.selectedSalesOfficer;
      }

      if (this.visibleSection === "business") {
        const sourcesOfIncome = [];
        const incomeData = Object.fromEntries(
          this.filteredBusinessIncome
            .filter(({ key, value }) => key && value)
            .map(({ key, value }) => [key, value]),
        );

        if (incomeData.annualIncome) {
          sourcesOfIncome.push({ annualIncome: incomeData.annualIncome });
        }

        const additionalIncome = {};
        if (incomeData.otherAnnualIncome) {
          additionalIncome.annualIncome = incomeData.otherAnnualIncome;
        }
        if (incomeData.otherIndustry) {
          additionalIncome.industry = incomeData.otherIndustry;
        }
        if (Object.keys(additionalIncome).length) {
          sourcesOfIncome.push(additionalIncome);
        }

        if (sourcesOfIncome.length) {
          payload.sourcesOfIncome = sourcesOfIncome;
        }
      }

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}/kyc/${endpoint}/${this.$route.params.agentId}`,
          payload,
        );

        if (response.status === 200) {
          this.$toast.success(response.data.message);
          await this.getAgent();
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
        this.isEditable = false;
      } finally {
        this.isUpdating = false;
      }
    },
    async updatePersonalInformation() {
      await this.updateInformation("update-personal-details");
    },
    async updateBusinessInformation() {
      await this.updateInformation("updateBusinessInformation");
    },
    async updateDirectorsInformation() {
      await this.updateInformation("update-director");
    },
    async updateShareholdersInformation() {
      await this.updateInformation("update-shareholder");
    },
    async updateTrusteesInformation() {
      await this.updateInformation("update-registeredTrustee");
    },
    async updateAuthorizersInformation() {
      await this.updateInformation("update-nominatedAuthorizer");
    },
    async getRequiredDocuments() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/required-docs/${this.$route.params.agentId}`,
        );

        if (response.data.status === "success")
          this.documentsToUpload = response.data.data.documentsToUpload;
      } catch (err) {
        // toast error message here.
      } finally {
        this.isUpdating = false;
      }
    },
    async updateKycDocuments() {
      this.isUpdating = true;
      const formData = new FormData();

      this.filteredDocuments.forEach((doc) => {
        if (doc.file) {
          formData.append(doc.key, doc.file);
        }
      });

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/upload-document/${this.$route.params.agentId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        const { status, message } = response.data;

        if (status === "success") {
          Swal.fire({
            icon: status,
            title: "ACCOUNT UPDATED",
            html: `<p><strong>${message}</strong></p>`,
            confirmButtonText: "OK",
            showCancelButton: false,
          }).then(() => {
            this.refreshPage();
          });

          await this.getAgent();
        }
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isUpdating = false;
      }
    },

    // async handleFieldClick(field) {
    //   try {
    //     if (typeof field.value !== "boolean") {
    //       if (field.key === "bvnValid") this.bvnValue = undefined;
    //       if (field.key === "nin") this.ninValue = undefined;
    //       return;
    //     }

    //     let response;
    //     if (field.key === "bvnValid") {
    //       response = await axios.post(
    //         `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`
    //       );
    //       this.bvnValue = response.data.bvn;
    //     } else if (field.key === "nin") {
    //       response = await axios.post(
    //         `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`
    //       );
    //       this.ninValue = response.data.nin;
    //     }
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // },

    async handleFieldClick(field) {
      try {
        // Handle Hide logic
        if (
          (field.key === "bvnValid" && this.isBvnVisible) ||
          (field.key === "nin" && this.isNinVisible)
        ) {
          if (field.key === "bvnValid") {
            this.bvnValue = null;
            this.isBvnVisible = false;
          } else if (field.key === "nin") {
            this.ninValue = null;
            this.isNinVisible = false;
          }
          return;
        }

        // Handle View logic
        let response;
        if (field.key === "bvnValid") {
          response = await axios.post(
            `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`,
          );
          this.bvnValue = response.data.bvn;
          this.isBvnVisible = true;
        } else if (field.key === "nin") {
          response = await axios.post(
            `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`,
          );
          this.ninValue = response.data.nin;
          this.isNinVisible = true;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  watch: {
    "utils.lgas"(newLgas) {
      if (this.activeLgaType === "residence") {
        this.utils.lgasOfResidence = newLgas;
      } else if (this.activeLgaType === "business") {
        this.utils.lgasOfOrigin = newLgas;
      }
    },
  },
  async mounted() {
    await this.getAgent();
    await this.getRequiredDocuments();
    this.getMerchants();
    this.getStates().then((states) => (this.utils.allStates = states));
  },
};
</script>

<style scoped>
select {
  background-color: #fafafa;
  font-size: 10px;
}

select::placeholder {
  color: #b6b6b4 !important;
}

select:disabled {
  background-color: #f5f5f5;
  color: #71797e;
}

.spin {
  border: 2px solid rgba(101, 179, 199, 0.2);
  border-left-color: #65b3c7;
  width: 15px;
  height: 15px;
}
</style>
